<div *ngIf="size == null">
  <mat-spinner color="primary" diameter="24"></mat-spinner>
</div>
<h2 class="page-header" *ngIf="size != null">{{ PRODUCTS.RAAMSTICKERS }}</h2>
<div class="table" *ngIf="size != null">
  <div class="form-title">
    <div class="form-title-text">
      <div class="table-cell" style="width: 5.5%">Formaat</div>
      <div class="table-cell" style="width: 16.5%">Materiaal</div>
      <div class="table-cell" style="width: 11%">Hoogte</div>
      <div class="table-cell" style="width: 11%">Breedte</div>
      <div class="table-cell" style="width: 11%">Tijd ontwerper</div>
      <div class="table-cell" style="width: 11%">Tijd kleefwerk</div>
      <div class="table-cell" style="width: 11%">Aanmaakprijs</div>
      <div class="table-cell" style="width: 11%">
        Plaatsingsprijs (tot 50 km)
      </div>
      <div class="table-cell" style="width: 11%">Som</div>
      <div class="table-cell" style="width: 12%"></div>
    </div>
  </div>
  <div class="form-body">
    <div
      class="form-row"
      *ngFor="let productSize of size.productSizes; index as i"
    >
      <div class="table-cell font-weight-bold">
        {{ computeFormatLabel(productSize) }}
      </div>
      <div class="table-cell">
        <mat-select
          matInput
          placeholder="Materiaal"
          [disabled]="!productSize.editable"
          [(ngModel)]="productSize.material"
          [compareWith]="compareMaterials"
          required
        >
          <mat-optgroup
            *ngFor="let group of productMaterials.materialGroups"
            [label]="group.label"
          >
            <mat-option
              *ngFor="let material of group.materials"
              [value]="material"
            >
              {{ material.name }}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </div>
      <div class="table-cell">
        <mat-form-field appearance="outline">
          <input
            type="number"
            matInput
            [disabled]="!productSize.editable"
            [(ngModel)]="productSize.height"
            required
          />
          <div matSuffix>{{ 'cm' }}</div>
        </mat-form-field>
      </div>
      <div class="table-cell">
        <mat-form-field appearance="outline">
          <input
            type="number"
            matInput
            [disabled]="!productSize.editable"
            [(ngModel)]="productSize.width"
            required
          />
          <div matSuffix>{{ 'cm' }}</div>
        </mat-form-field>
      </div>
      <div class="table-cell">
        <mat-form-field appearance="outline">
          <input
            type="number"
            matInput
            [disabled]="!productSize.editable"
            [(ngModel)]="productSize.designerMinutes"
          />
          <div matSuffix>{{ 'min' }}</div>
        </mat-form-field>
      </div>
      <div class="table-cell">
        <mat-form-field appearance="outline">
          <input
            type="number"
            matInput
            [disabled]="!productSize.editable"
            [(ngModel)]="productSize.placerMinutes"
          />
          <div matSuffix>{{ 'min' }}</div>
        </mat-form-field>
      </div>
      <div class="table-cell">
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            [(ngModel)]="productSize.productionPrice"
            [disabled]="!productSize.editable"
            class="text-right"
            matInput
            mask="0*,00"
            [dropSpecialCharacters]="false"
            required
          />
        </mat-form-field>
      </div>
      <div class="table-cell">
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input
            [(ngModel)]="productSize.placementPrice"
            [disabled]="!productSize.editable"
            class="text-right"
            matInput
            mask="0*,00"
            [dropSpecialCharacters]="false"
            required
          />
        </mat-form-field>
      </div>
      <div class="table-cell">
        <mat-form-field appearance="outline">
          <mat-icon matPrefix>euro_symbol</mat-icon>
          <input matInput [disabled]="true" [value]="computeSum(productSize)" />
        </mat-form-field>
      </div>
      <div class="table-cell">
        <div class="d-flex">
          <div
            *ngIf="!productSize.editable"
            class="padding-right clickable"
            (click)="toggleEditable(productSize)"
          >
            <mat-icon svgIcon="edit"></mat-icon>
          </div>
          <div
            *ngIf="productSize.editable"
            class="padding-right clickable"
            (click)="save(productSize, i)"
          >
            <mat-icon class="icon-size">save</mat-icon>
          </div>
          <div class="clickable" (click)="delete(productSize, i)">
            <mat-icon svgIcon="close"></mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="pull-left clickable" (click)="addProductSize()">
  <mat-icon svgIcon="add"></mat-icon>
</div>
<mat-paginator
  [length]="totalItems"
  [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="true"
></mat-paginator>
